import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MapPin, Users, Calendar, ShieldCheck, Wifi, Utensils, Zap } from 'lucide-react';
import { Button } from './Button';
interface PropertyModalProps {
  isOpen: boolean;
  onClose: () => void;
  property: {
    name: string;
    city: string;
    county: string;
    beds: string | number;
    status: string;
    img: string;
    address?: string;
    amenities?: string[];
  } | null;
}
export function PropertyModal({
  isOpen,
  onClose,
  property
}: PropertyModalProps) {
  if (!property) return null;
  return <AnimatePresence data-id="element-104">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6" data-id="element-105">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-charcoal/60 backdrop-blur-sm" data-id="element-106" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="relative w-full max-w-4xl bg-white rounded-3xl shadow-2xl overflow-hidden overflow-y-auto max-h-[90vh]" data-id="element-107">
            <button onClick={onClose} className="absolute top-4 right-4 z-10 p-2 bg-white/80 backdrop-blur-md rounded-full text-charcoal hover:bg-white transition-colors shadow-sm" data-id="element-108">
              <X size={20} data-id="element-109" />
            </button>

            <div className="flex flex-col md:flex-row" data-id="element-110">
              <div className="md:w-1/2 h-64 md:h-auto relative" data-id="element-111">
                <img src={property.img} alt={property.name} className="w-full h-full object-cover" data-id="element-112" />
                <div className="absolute top-4 left-4 px-4 py-1 bg-primary text-white rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-113">
                  {property.status}
                </div>
              </div>

              <div className="md:w-1/2 p-6 md:p-12 flex flex-col" data-id="element-114">
                <div className="mb-6" data-id="element-115">
                  <span className="text-xs font-bold text-accent uppercase tracking-widest mb-2 block" data-id="element-116">
                    {property.county} County
                  </span>
                  <h2 className="text-3xl font-display font-bold text-charcoal mb-2" data-id="element-117">
                    {property.name}
                  </h2>
                  <div className="flex items-center text-muted text-sm" data-id="element-118">
                    <MapPin size={16} className="mr-2 text-primary" data-id="element-119" />
                    {property.address || `${property.city}, Maryland`}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-120">
                  <div className="space-y-1" data-id="element-121">
                    <span className="text-[10px] font-bold text-muted uppercase tracking-wider" data-id="element-122">
                      Availability
                    </span>
                    <div className="flex items-center text-charcoal font-semibold" data-id="element-123">
                      <Users size={16} className="mr-2 text-primary" data-id="element-124" />
                      {property.beds}{' '}
                      {typeof property.beds === 'number' ? 'Beds' : ''}
                    </div>
                  </div>
                  <div className="space-y-1" data-id="element-125">
                    <span className="text-[10px] font-bold text-muted uppercase tracking-wider" data-id="element-126">
                      Move-in
                    </span>
                    <div className="flex items-center text-charcoal font-semibold" data-id="element-127">
                      <Calendar size={16} className="mr-2 text-primary" data-id="element-128" />
                      Ready Now
                    </div>
                  </div>
                </div>

                <div className="mb-8" data-id="element-129">
                  <h4 className="text-sm font-bold text-charcoal mb-4 flex items-center" data-id="element-130">
                    <ShieldCheck size={18} className="mr-2 text-primary" data-id="element-131" />
                    Property Highlights
                  </h4>
                  <div className="grid grid-cols-2 gap-3" data-id="element-132">
                    {['Wi-Fi Included', 'Shared Kitchen', 'Fully Furnished', 'Utilities Incl.'].map(item => <div key={item} className="flex items-center text-xs text-muted" data-id="element-133">
                        <div className="w-1.5 h-1.5 rounded-full bg-accent mr-2" data-id="element-134" />
                        {item}
                      </div>)}
                  </div>
                </div>

                <div className="mt-auto pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-4" data-id="element-135">
                  <Button className="flex-1" to="/contact" data-id="element-136">
                    Apply Now
                  </Button>
                  <Button variant="outline" className="flex-1" to="/contact" data-id="element-137">
                    Schedule Tour
                  </Button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}